import { render, staticRenderFns } from "./TasksCompleted.vue?vue&type=template&id=5ed51cc7"
import script from "./TasksCompleted.vue?vue&type=script&lang=js"
export * from "./TasksCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports